import { render, staticRenderFns } from "./mobile_approval.vue?vue&type=template&id=2222b2e7&vue-html=true"
import script from "./mobile_approval.vue?vue&type=script&lang=js"
export * from "./mobile_approval.vue?vue&type=script&lang=js"
import style0 from "./mobile_approval.vue?vue&type=style&index=0&id=2222b2e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports